export const mingdaoKey = {
    appKey: 'a40f482536524f6e',
    sign: 'Y2I4MDkxNjBhNzIzOWFiMDMzNWJhOGVhMTg2NzUwZDUwNWJmYzU1YWM1ZWI1YWE4MjQ3Yzg2ODYzNThiMGQxZQ==',
    secretKey: 'ed4169f4791e76e352a3582f9ece3740',
    worksheetId: 'xmjk'
}

export const mdApi = {
    getList: 'https://api.mingdao.com/v2/open/worksheet/getFilterRows',
    add: 'https://api.mingdao.com/v2/open/worksheet/addRow',
    update: 'https://api.mingdao.com/v2/open/worksheet/editRow'
}